<mat-sidenav-container class="dashboard-container">
    <!-- Sidebar -->
    <mat-sidenav #sidenav [mode]="isHandset ? 'over' : 'side'" [(opened)]="opened" class="sidenav">
        <mat-nav-list (click)="onNavClick(sidenav)">
            <mat-list-item>
              <button mat-button routerLink="dashboard" routerLinkActive="active-link">Dashboard
                <mat-icon routerLinkActive="active-link">dashboard</mat-icon>

              </button>
            </mat-list-item>
            <mat-list-item *ngIf="role == 'admin'">
              <button mat-button routerLink="categories" routerLinkActive="active-link">Categorías
                <mat-icon routerLinkActive="active-link">category</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item *ngIf="role == 'admin'">
              <button mat-button routerLink="providers" routerLinkActive="active-link">Tiendas
                <mat-icon routerLinkActive="active-link">store</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item>
              <button mat-button routerLink="products" routerLinkActive="active-link">Productos
                <mat-icon routerLinkActive="active-link">inventory</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item>
              <button mat-button routerLink="orders" routerLinkActive="active-link">Pedidos
                <mat-icon routerLinkActive="active-link">shopping_basket</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item *ngIf="role == 'admin'">
              <button mat-button routerLink="list-user" routerLinkActive="active-link">Usuarios
                <mat-icon routerLinkActive="active-link">person</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item *ngIf="role == 'admin'">
              <button mat-button routerLink="banners" routerLinkActive="active-link">Banners
                <mat-icon routerLinkActive="active-link">photo_library</mat-icon>
              </button>
            </mat-list-item>
            <mat-list-item>
              <button mat-button routerLink="my-profile" routerLinkActive="active-link">Mi perfil
                <mat-icon routerLinkActive="active-link">person</mat-icon>
              </button>
            </mat-list-item>
          </mat-nav-list>
    </mat-sidenav>
  
    <!-- Contenido Principal -->
    <mat-sidenav-content>
      <!-- Toolbar -->
      <mat-toolbar class="background-toolbar-header">
        <button mat-icon-button (click)="sidenav.toggle()" *ngIf="isHandset$ | async">
          <mat-icon>menu</mat-icon>
        </button>
              
        <span class="spacer"></span> <!-- Espacio flexible para alinear el menú a la derecha -->
      
        <!-- Avatar con iniciales y menú de opciones -->
        <button mat-button [matMenuTriggerFor]="userMenu" class="avatar-button">
          <span class="avatar-initials">{{ getUserInitials() }}</span>
        </button>
      
        <mat-menu #userMenu="matMenu">
          <button mat-menu-item (click)="logout()">
            <mat-icon>logout</mat-icon>
            Cerrar Sesión
          </button>
        </mat-menu>
      </mat-toolbar>
  
      <!-- Cuerpo donde el contenido será dinámico -->
      <div class="content-container">
        <router-outlet></router-outlet> <!-- Aquí se mostrará el contenido dinámico -->
      </div>
    </mat-sidenav-content>
  </mat-sidenav-container>
  